module.exports = __webpack_public_path__ + "static/art-3-d09abeff61e3efd1da2f0927c4fdfe29.jpg";